import BasicRoute from 'components/routes/BasicRoute'
import UsuarioConsulta from 'entity/User/components/UserConsulta'
import UserCreate from 'entity/User/components/UserCreate'
import UserForm from 'entity/User/components/UserForm'
import React from 'react'

export default function index() {
    return (
        <>
            <BasicRoute
                perfilAuth='r9jrEQXznNgjrZTGCfch'
                uid="consulta-usuario"
                route="consulta-usuario"
                menuProps={{
                    text: "Usuário",
                    sequence: "111111",
                    iconName: "Person",

                    parent: {
                        uid: "parentCadastros",
                        text: "Cadastros",
                        sequence: "222222",
                        iconName: 'Edit'
                    }
                }}

                element={<UsuarioConsulta />}
            />

            <BasicRoute
                uid="usuario"
                route="_usuario"
                element={<UserForm />}
            />

            <BasicRoute
                uid="cadastro-usuario"
                route="_cadastro-usuario"
                element={<UserCreate />}
            />
        </>
    )
}
